import type { ReactNode } from 'react';

import { Navigate, useLocation } from 'react-router';

import * as utils from '../../shared/utils';

const YEARS_ROUTE = '/years';

export const PrivateRoute = ({ children }: { children: ReactNode }) => {
  const hasToken = utils.isTokenExist();
  const currentYearId = utils.getCurrentYearIdFromLS();
  const currentYear = utils.getCurrentYearFromLS();
  const hasCurrentYear = !!currentYearId && !!currentYear;
  const location = useLocation();
  const isYearPage = location.pathname === YEARS_ROUTE;
  if (!hasToken) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (
    !hasCurrentYear &&
    !isYearPage &&
    location.pathname !== '/profile' &&
    location.pathname !== '/users'
  ) {
    return <Navigate to={YEARS_ROUTE} state={{ from: location }} />;
  }

  return children;
};
